import { CustomTypographyComponentProps } from "../types";
import { Typography } from "@mui/material";

export const Display2Typography = ({
  children,
  ...props
}: CustomTypographyComponentProps) => {
  return (
    <Typography variant={"display2" as any} {...props}>
      {children}
    </Typography>
  );
};
